export const formatConjunctionList = (
  names: string[],
  locale?: string,
): string => {
  if (!Array.isArray(names) || names.length === 0) {
    return '';
  }

  const bcp47Locale =
    typeof locale === 'string' ? locale.replace('_', '-') : undefined;

  try {
    const ListFormat = (
      Intl as unknown as {
        ListFormat: new (
          locale?: string,
          options?: { style: string; type: string },
        ) => { format: (list: string[]) => string };
      }
    ).ListFormat;

    return new ListFormat(bcp47Locale, {
      style: 'long',
      type: 'conjunction',
    }).format(names);
  } catch {
    return names.join(', ');
  }
};
